(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riaz-portfolio-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('riaz-commission-gallery')) {
    class RiazCommissionGallery extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-riaz-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.riazOpen));
            if (dialog) {
              dialog.showModal();
              dialog.querySelectorAll('video').forEach((video) => {
                video.currentTime = 0;
                video.play().catch(() => {});
              });
            }
          });
        });

        this.querySelectorAll('[data-riaz-close]').forEach((button) => {
          button.addEventListener('click', () => button.closest('dialog')?.close());
        });

        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
          dialog.addEventListener('close', () => {
            dialog.querySelectorAll('video').forEach((video) => video.pause());
          });
        });
      }
    }

    customElements.define('riaz-commission-gallery', RiazCommissionGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riaz-portfolio-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('riaz-commission-gallery')) {
    class RiazCommissionGallery extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-riaz-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.riazOpen));
            if (dialog) {
              dialog.showModal();
              dialog.querySelectorAll('video').forEach((video) => {
                video.currentTime = 0;
                video.play().catch(() => {});
              });
            }
          });
        });

        this.querySelectorAll('[data-riaz-close]').forEach((button) => {
          button.addEventListener('click', () => button.closest('dialog')?.close());
        });

        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
          dialog.addEventListener('close', () => {
            dialog.querySelectorAll('video').forEach((video) => video.pause());
          });
        });
      }
    }

    customElements.define('riaz-commission-gallery', RiazCommissionGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
